import { StorageKeys } from "src/core/analytics/dataMesh/common/enums";
import {
  DataMeshBufferPayload,
  DataMeshEventPayload,
} from "src/core/analytics/dataMesh/common/types";
import { base64toUint8Array } from "src/core/analytics/dataMesh/utils/bufferMethods/base64Converters";
import { dataMeshParamsStorage } from "src/core/analytics/dataMesh/utils/dbMethods/dataMeshParamsStorage";

export const getEventBuffer = async (): Promise<
  Array<DataMeshEventPayload>
> => {
  const eventsBufferString = await dataMeshParamsStorage.getItem(
    StorageKeys.SESSION_BUFFER
  );

  const buffer: Array<DataMeshBufferPayload> = JSON.parse(
    eventsBufferString || "[]"
  );

  return buffer.map((event) => ({
    ...event,
    payload: base64toUint8Array(event.payload),
  }));
};
